<div>
  <div class="form-inline">
    <div class="form-group">
      <div class="input-group">
        <div class="input-group-addon">{{ value }}</div>
        <div class="input-group-addon">{{ displayName }}</div>
        <div class="input-group-btn">
          <button pButton type="button" class="btn btn-default" icon="pi pi-search" (click)="showSearch()"></button>
        </div>
      </div>
    </div>
  </div>

  <p-dialog
    #invoiceLookupModal
    [(visible)]="showModal"
    modal="true"
    [closable]="true"
    styleClass="atlas-dialog-l"
    [focusOnShow]="false"
    [contentStyle]="{ 'max-height': '75vh' }"
  >
    <ng-template pTemplate="header">
      <h4 class="modal-title">{{ 'revenue.invoice-lookup.title' | translate | titlecase }}</h4>
      <div class="row">
        <div class="col-sm-6">
          <select class="form-control" [(ngModel)]="selectedRevenueItemNum" (ngModelChange)="onRevenueItemChange($event)">
            <option
              *ngFor="let item of revenueItems"
              [value]="item.ItemNum"
              [selected]="selectedRevenueItemNum == item.ItemNum ? true : null"
            >
              {{ item.ItemName }}
            </option>
          </select>
        </div>
        <div class="col-sm-6">
          <div class="form-inline">
            <div class="form-group">
              <div class="input-group">
                <input
                  (keydown.Enter)="executeSearch()"
                  autofocus
                  class="form-control"
                  type="text"
                  [(ngModel)]="invoiceSearchParams.Keyword"
                />
                <span class="input-group-btn">
                  <button
                    pButton
                    type="button"
                    class="btn btn-default"
                    icon="pi pi-search"
                    [label]="'common.search' | translate"
                    (click)="executeSearch($event)"
                  ></button>
                  <wl-busy [show]="isSearching"></wl-busy>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
    <div style="height: 375px">
      <div>
        <div *ngIf="searchHasResults == true && searchPerformed == true">
          <p-table [showGridlines]="true"
            scrollHeight="100%"
            scrollWidth="100%"
            [value]="invoiceResults.Result"
            [rows]="20"
            [paginator]="true"
            [pageLinks]="3"
            [rowsPerPageOptions]="[5, 10, 20]"
            [lazy]="true"
            [totalRecords]="invoiceResults.TotalCount"
            (onLazyLoad)="executeSearch($event)"
          >
            <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
              <SortAltIcon *ngIf="sortOrder === 0">
                <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
              </SortAltIcon>
              <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
                <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
              </SortAmountUpAltIcon>
              <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
                <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
              </SortAmountDownIcon>
            </ng-template>
            <ng-template pTemplate="header">
              <tr>
                <th [pSortableColumn]="'InvoiceNum'">
                  {{ 'common.revenue.invoice-number' | translate | titlecase }}
                  <p-sortIcon></p-sortIcon>
                </th>
                <th [pSortableColumn]="'BillToName'">
                  {{ 'common.personal-information.name' | translate | titlecase }}
                  <p-sortIcon></p-sortIcon>
                </th>
                <th [pSortableColumn]="'InvoiceDate'" class="text-center">
                  {{ 'common.revenue.invoice-date' | translate | titlecase }}
                  <p-sortIcon></p-sortIcon>
                </th>
                <th [pSortableColumn]="'DateDue'" class="text-center">
                  {{ 'common.revenue.date-due' | translate | titlecase }}
                  <p-sortIcon></p-sortIcon>
                </th>
                <th [pSortableColumn]="'AdjustedAmountDue'" class="text-center">
                  {{ 'common.revenue.amount-due' | translate | titlecase }}
                  <p-sortIcon></p-sortIcon>
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-invoice>
              <tr>
                <td>
                  <a (click)="selectInvoice(invoice.InvoiceNum)">{{ invoice.InvoiceNum }}</a>
                </td>
                <td>{{ invoice.BillToName }}</td>
                <td class="text-center">{{ invoice.InvoiceDate | date: 'shortDate' }}</td>
                <td class="text-center">{{ invoice.DateDue | date: 'shortDate' }}</td>
                <td class="text-center">{{ invoice.AdjustedAmountDue | currency }}</td>
              </tr>
            </ng-template>
          </p-table>
          <p-progressSpinner *ngIf="isSearching"></p-progressSpinner>
        </div>
      </div>
      <div *ngIf="!searchHasResults && searchPerformed">
        <h4>{{ 'common.phrases.no-results-found' | translate }}</h4>
      </div>
    </div>

    <ng-template pTemplate="footer">
      <div>
        <button pButton type="button" class="btn btn-default" (click)="this.showModal = false">Close</button>
      </div>
    </ng-template>
  </p-dialog>
</div>
